import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, numberWithCommas, kmFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class EntitywiseSentimentBreakupChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current && this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current && this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    tot = (sentiment) => {
        let tot = 0;
        let data = this.props.data[sentiment];

        data.map((val) => {
            tot = tot + val.y;
        });

        return tot;
    };

    getOptions = () => {
        let data = this.props.data;

        let self = this;
        const optionsOverTime = {
            chart: {
                type: "bar",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                backgroundColor: "transparent",
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                categories: data && data.keys,
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
            },
            legend: {
                enabled: this.props.showLegend,
                align: "center",
            },
            series: [
                {
                    name: "Positive",
                    data: data && data.positive,
                    dataLabels: {
                        inside: false,
                        x: 10,
                        formatter: function (e) {
                            // if (this.point.doc_count > 25) {
                            return `<p>${kmFormatter(this.y)}</p><br/>`;
                            // }
                        },
                        style: {
                            textOverflow: "ellipsis",
                        },
                    },
                    color: getSentimentColor("positive"),
                    marker: {
                        fillColor: getSentimentColor("positive"),
                        symbol: "square",
                    },
                },
                {
                    name: "Negative",
                    data: data && data.negative,
                    color: getSentimentColor("negative"),
                    marker: {
                        fillColor: getSentimentColor("negative"),
                        symbol: "square",
                    },
                    dataLabels: {
                        inside: false,
                        x: 10,
                        formatter: function (e) {
                            // if (this.point.doc_count > 25) {
                            return `<p>${kmFormatter(this.y)}</p><br/>`;
                            // }
                        },
                        style: {
                            textOverflow: "ellipsis",
                        },
                    },
                },
                {
                    name: "Neutral",
                    data: data && data.neutral,
                    color: getSentimentColor("neutral"),
                    marker: {
                        fillColor: getSentimentColor("neutral"),
                        symbol: "square",
                    },
                    dataLabels: {
                        inside: false,
                        x: 10,
                        formatter: function (e) {
                            // if (this.point.doc_count > 25) {
                            return `<p>${kmFormatter(this.y)}</p><br/>`;
                            // }
                        },
                        style: {
                            textOverflow: "ellipsis",
                        },
                    },
                },
            ],
            plotOptions: {
                bar: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        style: {
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            tooltip: {
                outside: true,
                shared: true,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: "normal",
                    zIndex: 2000,
                },
                borderColor: "white",
                backgroundColor: "#fff",
                borderRadius: 6,
                followPointer: true,
                followTouchMove: true,

                formatter: function () {
                    let tot = 0;
                    let sentiment = { positive: { value: 0, percentage: 0 }, negative: { value: 0, percentage: 0 }, neutral: { value: 0, percentage: 0 } };
                    this.points.map((point) => {
                        tot += point.y;
                        sentiment[point.point.sentiment].value = point.y;
                    });

                    sentiment.positive.percentage = ((sentiment.positive.value / tot) * 100).toFixed(2);
                    sentiment.negative.percentage = ((sentiment.negative.value / tot) * 100).toFixed(2);
                    sentiment.neutral.percentage = ((sentiment.neutral.value / tot) * 100).toFixed(2);
                    return `<span>${this.x}</span><br /><span>Positive: <b>${sentiment.positive.percentage}%</b> | 
                   </span> <span><b>${numberWithCommas(sentiment.positive.value)}</b> / <b>${numberWithCommas(tot)}</b></span><br />
                   <span>Negative: <b>${sentiment.negative.percentage}%</b> | 
                   </span> <span><b>${numberWithCommas(sentiment.negative.value)}</b> / <b>${numberWithCommas(tot)}</b></span><br />
                   <span>Neutral: <b>${sentiment.neutral.percentage}%</b> | 
                   </span> <span> <b>${numberWithCommas(sentiment.neutral.value)}</b> / <b>${numberWithCommas(tot)}</b></span><br />
                    `;
                },
            },
        };

        return optionsOverTime;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default EntitywiseSentimentBreakupChart;
